import { owcTheme } from '@one/design-tokens/js/regular/navify/light';
import { OwcMenu } from '@one/react';
import styled from 'styled-components';

export const UserAvatarMenu = styled(OwcMenu)`
  owc-popover {
    width: 250px !important;
  }

  /* ODSU's own list limit, or what is left after the header bar, menu header, footer and a margin */
  owc-list {
    max-height: min(
      ${owcTheme['one-sizer-base-600']},
      calc(100vh - ${owcTheme['one-sizer-base-400']})
    ) !important;
    overflow-y: auto !important;
  }
`;
